var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fff"},attrs:{"id":"singleModule"}},[_c('div',{staticClass:"moduleContainer"},[_c('ModuleTitle',{attrs:{"title":_vm.title}}),_c('img',{staticClass:"imgSize",attrs:{"src":"https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/website/joinUs/joinUs4.png","alt":"show"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }